var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('channel-edit',{attrs:{"loading":_vm.loading,"channel":_vm.currentChannel,"isEditMode":true,"new-channel":false},on:{"save-channel":_vm.updateChannel,"delete-channel":_vm.deleteChannel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }